export default {
  type: 'menu',
  code: '21000000',
  rust: {
    type: 'menu',
    code: '21010000',
    contractManage: {
      type: 'menu',
      code: '21010100',
      upload: {
        type: 'btns',
        code: '21010101'
      }
    },
    taskManage: {
      type: 'menu',
      code: '21010200',
      refresh: {
        type: 'btns',
        code: '21010201'
      },
      create: {
        type: 'btns',
        code: '21010202'
      }
    }
  },
  solidity: {
    type: 'menu',
    code: '21020000',
    contractManage: {
      type: 'menu',
      code: '21020100',
      upload: {
        type: 'btns',
        code: '21020101'
      }
    },
    taskManage: {
      type: 'menu',
      code: '21020200',
      refresh: {
        type: 'btns',
        code: '21020201'
      },
      create: {
        type: 'btns',
        code: '21020202'
      }
    }
  }
}
